import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { CheckCircle, Loader2, Download } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ConfirmacionPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const session_id = searchParams.get("session_id");
  const [loading, setLoading] = useState(true);
  const [boletos, setBoletos] = useState([]);
  const [compradorId, setCompradorId] = useState(null);

  useEffect(() => {
    if (session_id) {
      verificarPago();
    } else {
      navigate("/");
    }
  }, [session_id]);

  const verificarPago = async () => {
    let attempts = 0;
    const maxAttempts = 10;

    const checkStatus = async () => {
      try {
        const response = await axios.get(`${API}/checkout/status/${session_id}`);
        
        if (response.data.payment_status === "paid") {
          setBoletos(response.data.boletos || []);
          if (response.data.boletos && response.data.boletos.length > 0) {
            setCompradorId(response.data.boletos[0].comprador_id);
            localStorage.setItem("compradorId", response.data.boletos[0].comprador_id);
          }
          setLoading(false);
          toast.success("¡Pago exitoso! Tus boletos han sido generados.");
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkStatus, 2000);
        } else {
          setLoading(false);
          toast.error("No se pudo verificar el pago. Por favor contacta al soporte.");
        }
      } catch (error) {
        console.error("Error verificando pago:", error);
        if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkStatus, 2000);
        } else {
          setLoading(false);
          toast.error("Error verificando el pago");
        }
      }
    };

    checkStatus();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-warm-bone flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="animate-spin h-16 w-16 text-zuno-wine mx-auto mb-4" />
          <p className="text-xl text-slate-600">Verificando tu pago...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-warm-bone py-12">
      <div className="container mx-auto px-6 md:px-12 lg:px-24 max-w-4xl">
        <div className="glass-card rounded-3xl p-8 md:p-12 text-center">
          <CheckCircle className="h-24 w-24 text-green-500 mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-bold text-zuno-wine mb-4">
            ¡Compra Exitosa!
          </h1>
          <p className="text-xl text-slate-600 mb-8">
            Tus boletos han sido enviados a tu correo electrónico
          </p>

          <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl p-6 mb-8">
            <h2 className="text-2xl font-semibold text-zuno-wine mb-4">
              Boletos Generados: {boletos.length}
            </h2>
            <div className="space-y-3">
              {boletos.map((boleto, index) => (
                <div
                  key={boleto.numero_boleto}
                  className="bg-white rounded-lg p-4 border-2 border-slate-200"
                  data-testid={`ticket-${index}`}
                >
                  <p className="font-mono font-semibold text-lg">
                    {boleto.numero_boleto}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate(`/mis-boletos/${compradorId}`)}
              className="btn-primary"
              size="lg"
              data-testid="view-tickets-btn"
            >
              <Download className="mr-2" />
              Ver Mis Boletos
            </Button>
            <Button
              onClick={() => navigate("/")}
              variant="outline"
              className="btn-secondary"
              size="lg"
              data-testid="back-home-btn"
            >
              Volver al Inicio
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmacionPage;
